import * as actions from './actions';

const standingOrderTypeModule = {
  namespaced: true,
  actions,
};

export default standingOrderTypeModule;
